module.exports = __webpack_public_path__ + "static/img/logo.8e9082a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 27